"use strict";
/**
 * @description 标题
 * @author wangfupeng
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DropListMenu_1 = __importDefault(require("../menu-constructors/DropListMenu"));
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var Head = /** @class */ (function (_super) {
    __extends(Head, _super);
    function Head(editor) {
        var _this = this;
        var $elem = dom_core_1.default('<div class="w-e-menu"><i class="w-e-icon-header"></i></div>');
        var dropListConf = {
            width: 100,
            title: '设置标题',
            type: 'list',
            list: [
                { $elem: dom_core_1.default('<h1>H1</h1>'), value: '<h1>' },
                { $elem: dom_core_1.default('<h2>H2</h2>'), value: '<h2>' },
                { $elem: dom_core_1.default('<h3>H3</h3>'), value: '<h3>' },
                { $elem: dom_core_1.default('<h4>H4</h4>'), value: '<h4>' },
                { $elem: dom_core_1.default('<h5>H5</h5>'), value: '<h5>' },
                {
                    $elem: dom_core_1.default("<p>" + editor.i18next.t('menus.dropListMenu.head.正文') + "</p>"),
                    value: '<p>',
                },
            ],
            clickHandler: function (value) {
                // 注意 this 是指向当前的 Head 对象
                _this.command(value);
            },
        };
        _this = _super.call(this, $elem, editor, dropListConf) || this;
        return _this;
    }
    /**
     * 执行命令
     * @param value value
     */
    Head.prototype.command = function (value) {
        var editor = this.editor;
        var $selectionElem = editor.selection.getSelectionContainerElem();
        if ($selectionElem && editor.$textElem.equal($selectionElem)) {
            // 不能选中多行来设置标题，否则会出现问题
            // 例如选中的是 <p>xxx</p><p>yyy</p> 来设置标题，设置之后会成为 <h1>xxx<br>yyy</h1> 不符合预期
            return;
        }
        editor.cmd.do('formatBlock', value);
    };
    /**
     * 尝试改变菜单激活（高亮）状态
     */
    Head.prototype.tryChangeActive = function () {
        var editor = this.editor;
        var reg = /^h/i;
        var cmdValue = editor.cmd.queryCommandValue('formatBlock');
        if (reg.test(cmdValue)) {
            this.active();
        }
        else {
            this.unActive();
        }
    };
    return Head;
}(DropListMenu_1.default));
exports.default = Head;
